// 整个vue初始化前，需要做的一些处理
import store from './store';
import Vue from 'vue';
import router from './router';
import { setRouter } from './router';
import Utils, { getQueryString,isMobile } from './utils/index.js';
import { adaptRCUtil } from './utils/RCUtil.js';
import kmuiTabIdMixin from './mixins/kmuiTabIdMixin.js';
import { loadUserInfo, switchIdentity,loginChoose } from './pages/login/servers.js';
import { getCompanyInfo } from '@/api/login-api.js';
import qs from 'query-string';
import { defineCommonConfig } from '@@erp/entry/defineCommonConfig.js';

// 不需要用户信息的页面
let unLoginUrl = [
  '/login/register',
  '/unlogin/distributeShop',
  '/unlogin/productDetail',
  '/unlogin/wxMiniRedirect',
  '/login/forgetPassowrd',
  '/pdd/outer_link',
  '/outdetail/outer_link',
]

// 外部跳转的链接，直接加载当前页面
let loadCurUrl = {
  '/supplier/dangkou/shipment/detail' : 1,
  '/supplier/management/invitation' : 1,
  '/supplier/commodity/myShop' : 1,
  '/supplier/prod/center':1,
  '/supplier/prod_conf':1,
  '/supplier/prod_relationship': 1,
  '/supplier/management/mine':1,
  '/supplier/management/priceControl':1,
  '/distributor/supplier/mine':2,
  '/distributor/supplier/info': 2,
  '/distributor/prod/center': 2,
  '/distributor/shopManage': 2,
  '/distributor/prod/log':2,
  '/distributor/trade/order/audit':2,
  '/hyc/bulkShelves': 2,
  '/hyc/batchBulkShelves': 2,
  '/hyc/groupBulkShelves': 2
}
export function isUnlogin() {
  return unLoginUrl.includes(window.location.pathname);
}

// 初始化地址
// 防止一个浏览器开了不同页面，刷新后导致页面不一致
function initLocation() {
  window.addEventListener('storage', function (e) {
    if (e.key === '_need_init_location' && e.newValue === 'true') {
      window.sessionStorage.setItem('_need_init_location', true);
    }
  });

  if (!/^(\/supplier|\/distributor)/.test(window.location.pathname)) {
    // 非大小b端内页将不进行跳转
    return;
  }

  let _last_href = window.localStorage.getItem('_last_href');
  let _need_init_location = window.sessionStorage.getItem('_need_init_location');
  // 1. 有最后一次地址且地址与当前地址不同 2. 需要初始化地址标识为true --- 这个标识由不同登录者登录后置为true
  if (_last_href && _last_href !== window.location.href && _need_init_location === 'true') {
    window.location.href = _last_href;
    window.sessionStorage.setItem('_need_init_location', false);
  }
}

// 初始化供分销绑定vuex
// 用于登录、选择身份后的跳转
function initRelationBind() {
  const _currRoute = window.location;
  const needBindPathNames = [
    // 需要绑定关系的路由名集合
    '/supplier/management/mine', // 大b端的我的分销商
    '/supplier/management/mine/', // 大b端的我的分销商
    '/distributor/supplier/mine', // 小b端的我的供销商
    '/distributor/supplier/mine/', // 小b端的我的供销商
    '/supplier/dangkou/shipment/detail',
    '/supplier/dangkou/shipment'
  ];
  if (needBindPathNames.includes(_currRoute.pathname) && /inviteId/.test(_currRoute.search)) {
    store.dispatch('setBindRelationUrl', _currRoute.pathname + _currRoute.search);
  }
}

// 没有选身份的自动跳转
export async function autoJump(){
  let share_location = sessionStorage.getItem('_share_location_');
  const searchs = qs.parse(location.search);
  let isAutoChooseRole = share_location && share_location.indexOf('/distributor/supplier/mine') != -1;

  if(share_location && isAutoChooseRole){
    // 通过邀请链接注册进来的默认自动选对应的身份,目前只做供销商邀请分销商的情况
    let loginIdentity = 2
    const isSuccess = await loginChoose({loginIdentity});
    if (!isSuccess) return ;
    const success = await loadUserInfo();
    if (success) {
      if(loginIdentity == 2){
        router.replace(JSON.parse(share_location))
      }else{
        router.replace({
          path: '/login/choose',
          query: {
            redirectUrl: location.pathname,
            ...searchs,
          }
        });
      }
    } else {
      this.$message.error('获取身份信息失败')
    }
  }else{
    router.replace({
      path: '/login/choose',
      query: {
        redirectUrl: location.pathname,
        ...searchs,
      }
    });
  }
}

export async function roleJudge() {
  const pathname =  window.location.pathname;


  // 若用户未选择角色 需要跳转至角色选择页
  let loginIdentity = store.getters?.userInfo?.loginIdentity;
  let isPHAI = false
  try {
    const ciRes = await getCompanyInfo();
    isPHAI = ciRes && ciRes.versionNumber === 'PH-AI'
    // if (ciRes && ciRes.versionNumber === 'PH-AI') {
    //   if (Number(loginIdentity) !== 2) {
    //     if (loginIdentity === '0' || loginIdentity === 0 || loginIdentity === undefined || loginIdentity === null) {
    //       const chooseOk = await loginChoose({ loginIdentity: 2 });
    //       if (chooseOk) {
    //         const ok = await loadUserInfo();
    //         if (ok) {
    //           loginIdentity = store.getters?.userInfo?.loginIdentity;
    //         }
    //       }
    //     } else {
    //       await switchIdentity(2);
    //       location.reload();
    //       return;
    //     }
    //   }
    // }
  } catch (e) {
    console.log(e);
  }
  if (loginIdentity === '0' || loginIdentity === 0) {
    autoJump();
    // const searchs = qs.parse(location.search);
    // router.replace({
    //   path: '/login/choose',
    //   query: {
    //     redirectUrl: location.pathname,
    //     ...searchs,
    //   }
    // });
  } else if (loadCurUrl[pathname] == loginIdentity) {
    // 不跳转，直接当前页面
    // if(pathname == '/distributor/shopManage' && !location.search.includes('reloaded=true') ){
    //   location.href = `${location.pathname}?reloaded=true`;
    // }
  } else if(loginIdentity == 2 && loadCurUrl[pathname]){ // 如果是erp调过来的分销小店，需自动从分销版切换为供销版
    console.log('如果是erp调过来的分销小店，需自动从分销版切换为供销版-=-=-=-=-=-=-=');
    switchIdentity(1);
    location.reload()
  } else if(loginIdentity == 1 && loadCurUrl[pathname]){ // erp跳转过来的分销外链 
    console.log('erp跳转过来的分销外链-=-=-=-=-=-=-=');
    switchIdentity(2);
    location.reload();
  } else if(loginIdentity == 1 && isPHAI){ // 分销版跳转过来的分销小店，需自动从分销版切换为供销版
    switchIdentity(2);
    location.reload()
  } else if (!/^(\/login)/.test(pathname)) {
    router.replace('/');
  }
};

export async function preInit() {
  // 判断是否是货源池跳转过来的
  Vue.prototype.$fromGyl = getQueryString('from') === 'gyl';
  Vue.prototype.$puhuoDialog = getQueryString('puhuoDialog');

  let pathname =  window.location.pathname;
  
  // 如果是货源池过来铺货，渲染前切换为分销版，防止两次渲染
  if (Vue.prototype.$fromGyl && (pathname == '/hyc/bulkShelves' || pathname == '/hyc/batchBulkShelves' || pathname == '/hyc/groupBulkShelves')) {
    switchIdentity(2);
  }

  // 兼用kmui店铺选择弹窗，默认取RayCloud.util.getPlatfromList方法获取最新平台数据
  Utils.platform.adaptKmui();
  adaptRCUtil();
  import(`@@c/vue/components/index.js`);
  defineCommonConfig('COMMON_STORAGE_CONF');

  // 初始化 cookie中的 _ati
  Utils.cookie.reset_ati();
  initLocation();
  initRelationBind();
  // 初始化路由及身份信息，防止刷新后路由丢失
  // hasCookie=true 如果存在就不从本地拿信息，一般是从其他平台跳过来，已经携带了cookie
  const hasCookie = window.location.search.indexOf('hasCookie=true') > -1;

  const _isMobile = isMobile();
  // 不同环境邀请供分销，没有cookie，记录邀请链接，登录后跳转
  if(!hasCookie){
    let location = window.location;
    if (location.href.includes('supplier/management/mine') || location.href.includes('distributor/supplier/mine')){
      sessionStorage.setItem('_share_location_', JSON.stringify(pathname + location.search));
    }
  }
  // 移动端打开邀请链接跳转到小程序（无论有无cookie都要跳转）
  if(_isMobile){
    const _location = window.location;
    if (_location.href.includes('supplier/management/mine') || _location.href.includes('distributor/supplier/mine')){
      const searchs = qs.parse(_location.search);
      if (searchs.inviteId) {
        let query = `supplierCompanyId=${searchs.inviteId}&fromLoginIdentity=1&invitation=1`;
        let path = '/supplier/list/index'
        if(_location.href.includes('supplier/management/mine')){
          query = `distributorCompanyId=${searchs.inviteId}&fromLoginIdentity=2&invitation=2`;
          path = '/pages/index/index';
        }
        router.push({
          path: '/unlogin/wxMiniRedirect',
          query: {
            path,
            query,
          }
        })
      }
    }
    return;
  }

  const isGet = await loadUserInfo({ f_local: !hasCookie, isUnlogin: isUnlogin() });
  if (!isGet && hasCookie) {
    window.alert('登录已失效，请重新登录');
  } else if (hasCookie) {
    await roleJudge();
  }

  // TODO: 需要后端提供一个登录完的cookie接口，在后端处完成重定向
  // console.log(store.getters.userInfo, '---isGet');
  // window.location.href = 'http://scm.superboss.cc?hasCookie=true';

  // 将每次跳转后的地址存在localStorage里
  router.afterEach((to, from) => {
    window.localStorage.setItem('_last_href', window.location.href);
  });

  // 防止跳到空白页
  router.beforeEach((to, from, next) => {
    
    const existRoutes = router.getRoutes();
    if (existRoutes.findIndex(item => item.name === to.name) > -1 || to.params.f_next) {
      next();
    } else {
      next({ name: '404', params: { f_next: true } });
    }
  });

  // tabs的路由拦截处理
  router.beforeEach((to, from, next) => {
    if (store.getters.isKeepAlive) {
      store.commit('setRefreshRouterName', '');
    } else {
      store.commit('setRefreshRouterName', to.name);
    }
    
    // 森林说TJ的配置是临时给ERP用的，不要当成公共配置，tab不刷新写死为true
    let tabNoRefresh = true;
    store.commit('setIsKeepAlive', tabNoRefresh);
    next();
  });
  store.dispatch('initShops');  // 缓存店铺数据
  store.dispatch('getGoodsFissionConfig');  // 缓存ai裂变配置

  // 一些全局所需的函数或库
  Vue.prototype.$setRouter = setRouter;
  Vue.prototype.$utils = Utils;
  Vue.mixin(kmuiTabIdMixin); // kmui所需id
}
